export default __webpack_public_path__ + "static/media/coop.6d3ab706.png";